import React from 'react'
import { FormField } from '../FormField/FormField'

export const FormText: React.FC<{ label: string; children?: React.ReactNode }> = ({ label, children }) => {
  return <FormField label={label} render={() => children} />
}
